import React, {Table, Component } from 'react';
import ReactDOM from 'react-dom';
import Swal from 'sweetalert2';
import { API_URL, isEmpty, SwalUnBlokUI,SwalBlokUI } from '../../config'
import $ from 'jquery'
 import { ShowSwallError } from '../../config'
import './order.css'
import MaterialTable, { MTableToolbar } from 'material-table';
import {Button} from 'react-bootstrap'
import Dialog from 'react-bootstrap-dialog'
 
class ViewOrderNew extends Component { 
    tableRef = React.createRef();
    constructor(props) {
        super(props);
        const grid_height= $(window).height()-$(".header-navbar").height()-200;
        this.max_body_heght= grid_height+"px";
        this.state = { 
            idx:0,
            popup_total:0,
            orddet:[],
            orddeta:[],
            pop_up_order_no:"",
            pop_up_order_date:"",
            pop_up_dist:"",


        } 

    }
     componentDidMount(){  console.clear() 
       
       
           
      //  this.ShowMyOrders()
    } 
    ShowMyOrders() {
         const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','authorization': localStorage.getItem('token') },
         
        };
 
        let logourl = API_URL + "/allSalesOrders";
        fetch(logourl, requestOptions)
            .then(res => res.json())
            .then(json => {
              this.setState({orddet:json})
            })
            .catch( (e) => {
                ShowSwallError(e)              
            })
        //////////////////////////////

    }
    GetItemDetailsForOrderNo(val,row_total,row_obj) {
     
        this.setState({popup_total:row_total}) 

        this.setState({pop_up_order_no:val}) 
        this.setState({pop_up_order_date:row_obj.creation_date}) 
        this.setState({pop_up_dist:row_obj.customer_name}) 

      

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','authorization': localStorage.getItem('token') }        
        };
 
        let logourl =  API_URL + '/order_master/orderDetails?orderNo='+val;
        fetch(logourl, requestOptions)
            .then(res => res.json())
            .then(json => {              
                this.setState({orddeta:json['data']})              
            
            })
            .catch( (e) => {
                ShowSwallError(e)       
            }) 
    } 
    //https://github.com/akiroom/react-bootstrap-dialog/blob/master/stories/stories/ShowPrompt.js
  ApproveRejectRequest(status,row_obj){
    let def_val=""; 
    let body="Do You want to Reject This Request"; 
    if(status=="Approved not Uploaded")
      {
        def_val="Approved";;
        body=" Do You want to Approve This Request"; 
      }
        //alert(status)
        //alert(row_obj.customer_ref_no);
        this.dialog.show({
            body: body,
            prompt: Dialog.TextPrompt({placeholder: 'Remarks', initialValue: def_val,required:true}),
            actions: [
              Dialog.CancelAction(),
              Dialog.OKAction((dialog) => {
                const remarks= dialog.value

                this.ApproveViaAjax(status,row_obj.customer_ref_no,remarks);
 
                
              })
            ]
          });
        
      
        /*
        this.dialog.show({
            title: 'Greedings',
            body: 'How are you?',
            actions: [
              Dialog.CancelAction(),
              Dialog.OKAction()
            ],
            bsSize: 'small',
            onHide: (dialog) => {
              dialog.hide()
              console.log('closed by clicking background.')
            }
          }) 
*/
         

          
        //this.dialog.showAlert(status)
     
   }
   ApproveViaAjax(appr_status,customer_ref_no,remarks)
   {
    SwalBlokUI("Please Wait...Updating");
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json','authorization': localStorage.getItem('token') }   
        
    };

    let logourl =  API_URL + '/order_master/ApproveRejectRequests?appr_status='+appr_status+"&customer_ref_no="+customer_ref_no+"&remarks="+remarks+"&appr_by="+localStorage.empCode;
    fetch(logourl, requestOptions)
        .then(res => res.json())
        .then(json => {              
               
            // Swal.fire(
            //     'Done',
            //     json.data.msg,
            //     'success'
            //   )
           // let msg=customer_ref_no+" </br> <span style='color:red'>"+json.data.msg+"</span> ";
              Swal.fire(
                'Done',
                json.data.msg,
                'success'
              )

           
            this.tableRef.current.onQueryChange();
            SwalUnBlokUI();
        
        })
        .catch( (e) => {
            ShowSwallError(e)     
            SwalUnBlokUI();  
        }) 


    
   }
    render() {
        let { subject, idx } = this.state

        return (
            <>

            <div className="App">
                 
                <MaterialTable  style={{border: '0px solid red'}} 
                      tableRef={this.tableRef}
                    title="View Order" minRows={10}
                    columns={ [
                        { title: "Order No", field: "customer_ref_no" },
                        { title: "Order Date", field: "creation_date" },
                        { title: "Distributor Name", field: "customer_name",width: "30%"  },
                        { title: "Order Qty", field: "quantity",align:"right" },
                        { title: "Order Amount", field: "total",align:"right"  },
                        { title: "Invoice Qty", field: "invoice_qty",align:"right"  },
                        { title: "Invoice Amount", field: "invoice_amt",align:"right"  },
                        { title: "Status", field: "status" }   ,
                        { title: "ERP Ref No.", field: "erp_ref_no" },
                      ]}
                    options={{maxBodyHeight: this.max_body_heght, debounceInterval: 700, padding: "dense", exportButton: true,filtering: false,
                    headerStyle: {
                        position: "sticky",
                        top: "0",
                        backgroundColor: "#64a179",
                        color: "#FFF",
                        fontSize: "0.9em"
                    },
                    rowStyle: (rowData) => ({
                        fontSize: "1em",
                        backgroundColor:
                        rowData.tableData.id % 2 === 1 ? "#e8f5e2" : "#ffffff"
                    }),
                        pageSize: 25,
                        pageSizeOptions: [25 ,50, 75, 100 ],
                        toolbar: true,
                        paging: true,
                        actionsColumnIndex: -1
                    }}
                    data={query =>
                        new Promise((resolve, reject) => {
                            // prepare your data and then call resolve like this:
                            let url =  API_URL +'/order_master/GetOrderGridData?'
                            let q_search="";
                            let sort="";
                            let order_by="";
                            //searching
                            if (query.search) {
                                q_search=`${query.search}`;
                            }
                            //sorting 
                            if (query.orderBy) {
                                sort= `${query.orderBy.field}`;
                                order_by=`${query.orderDirection}`
                            }
                            url += "&q_search="+q_search
                            url += "&sort="+sort
                            url += "&order_by="+order_by

                            //filtering
                            if (query.filters.length) {
                                const filter = query.filters.map(filter => {
                                    return `&${filter.column.field}${filter.operator}${filter.value}`
                                })
                                url += filter.join('')
                            }
                            //pagination
                            url += `&page=${query.page + 1}`
                            url += `&limit=${query.pageSize}`
                            console.clear();

                             //request options
                            const requestOptions = {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'authorization': localStorage.getItem('token')
                                },
                                // body: JSON.stringify(data1)
                            };
                              
                            fetch(url,requestOptions).then(resp => resp.json()).then(resp => {
                            resolve({
                                data: resp['data']['data'],// your data array
                                page: query.page,// current page number
                                totalCount:  resp['data']['total_records']// total row number
                            });
                            })

                        })
                    }
                  
                    actions={[
                        {
                            icon: () => (
                           
                                <i class="fas fa-eye" style={{color:"#870f9d"}}></i>
                              ),
                          iconProps: 'primary',
                          tooltip: 'View Details',
                          onClick: (event, rowData) => {
                              // Do save operation
                                window.$(".modal").modal("show");
                            // this.ApproveViaAjax('');
                              this.GetItemDetailsForOrderNo(rowData.customer_ref_no,rowData.total,rowData)
                                //  this.edit(rowData)
                          }
                        } ,
                        //https://mui.com/components/material-icons/
                            
                            (rowData) => {
                                return {
                                    icon: () => (
                                        rowData.pending_with === localStorage.empCode && rowData.status==="Waiting for Approval"?    <i class="fas  fa-check-square" style={{color:"#0f9d27"}}></i>:""
                                      ),
                                  tooltip: "Approve",
                                 // disabled: rowData.status === "active",
                                //   hidden: rowData.pending_with === "3",
                                  onClick: (event, rowData) =>
                                  this.ApproveRejectRequest("Approved not Uploaded",rowData)
                                   // alert("This client status is " + rowData.status)
                                };
                              },
                              (rowData) => {
                                return {
                                    icon: () => (
                                        rowData.pending_with === localStorage.empCode && rowData.status==="Waiting for Approval"?  <i class="fas  fa-window-close" style={{color:"#f15308"}}></i>:""
                                      ),
                                  tooltip: "Reject",
                                 // disabled: rowData.status === "active",
                                //   hidden: rowData.pending_with === "3",
                                onClick: (event, rowData) =>
                               this.ApproveRejectRequest("Rejected",rowData)
                               // alert("This client status is " + rowData.status)
                                   };
                              }
                          
                      ]}
                />

                <div class="modal-size-xl d-inline-block">  
                <Dialog ref={(component) => { this.dialog = component }} />
                    <div class="modal fade text-left" id="xlarge" tabindex="-1" role="dialog" aria-labelledby="myModalLabel16" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title" id="myModalLabel16">Line Items Details</h4>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                <table className=" table-bordered table" style={{width:"90%"}}>
  <thead>
    <tr  >
      <th style={{background:"#e8f5e2",color:"#000",textAlign:"left",padding:"3px",width:"5%"}} >Order No: </th><th style={{background:"#ebf5f3",color:"#000",padding:"3px",width:"5%"}}><b>{this.state.pop_up_order_no}</b></th> 
      <th style={{background:"#e8f5e2",color:"#000",textAlign:"left",padding:"3px",width:"5%"}} >Order Date</th><th style={{background:"#ebf5f3",color:"#000",padding:"3px",width:"5%"}}><b> {this.state.pop_up_order_date} </b></th>
      <th style={{background:"#e8f5e2",color:"#000",textAlign:"left",padding:"3px",width:"5%"}} >Distributor</th><th style={{background:"#ebf5f3",color:"#000",padding:"3px",width:"20%"}}><b> {this.state.pop_up_dist}</b></th>
    </tr>
  </thead>
   
</table>
                                <div class="table-responsive table-wrapper-scroll-y my-custom-scrollbar_items">
                                <table class="table-responsive datatables-basic table p-0 m-0 shadow table-hover table-sm">

                                <thead>
                                    <tr>
                                    {/* <th style={{backgroundColor:"#64a179",color: "#FFF",fontSize: "0.9em" }}>Order Date</th>
                                        <th style={{backgroundColor:"#64a179",color: "#FFF",fontSize: "0.9em" }}>Order No</th>
                                        <th style={{backgroundColor:"#64a179",color: "#FFF",fontSize: "0.9em" }}>Distributor Name</th> */}
                                        <th style={{backgroundColor:"#64a179",color: "#FFF",fontSize: "0.9em" }}>Parent Item Code</th>
                                        <th style={{backgroundColor:"#64a179",color: "#FFF",fontSize: "0.9em" }}>Item Code</th>
                                        <th style={{backgroundColor:"#64a179",color: "#FFF",fontSize: "0.9em",width:"30%" }}>Item Desc</th>
                                        <th style={{backgroundColor:"#64a179",color: "#FFF",fontSize: "0.9em" }}>Item Price</th>
                                        <th style={{backgroundColor:"#64a179",color: "#FFF",fontSize: "0.9em" }}> Quantity </th>
                                        <th style={{backgroundColor:"#64a179",color: "#FFF",fontSize: "0.9em" }}> Unit </th>
                                        <th style={{backgroundColor:"#64a179",color: "#FFF",fontSize: "0.9em",textAlign:"right" }} > Order Amount </th>
                                        <th style={{backgroundColor:"#64a179",color: "#FFF",fontSize: "0.9em",textAlign:"right" }} > Invoice Qty </th>
                                        <th style={{backgroundColor:"#64a179",color: "#FFF",fontSize: "0.9em",textAlign:"right" }} > Invoice Amount </th>
                                    
                                       
                                    </tr>
                                </thead>
                                <tbody table-hover-animation>

                                {
                             
                                this.state.orddeta.map((data,index)  => ( 
                                        <tr  style={{backgroundColor: index%2===1 ? "#e8f5e2" : "#ffffff"}}  key={index}>
                                        
                                            {/* <td>{data.orderdate}</td>
                                            <td>{data.orderno}</td>
                                            <td>{data.distributorname}</td> */}
                                            <td>{data.parent_item_code}</td>
                                            <td>{data.itemcode}</td>
                                            <td style={{width:"30%"}}>{data.itemdesc}</td>
                                            <td>{parseFloat(data.itemprice).toFixed(2)}</td>
                                            <td>{parseFloat(data.quantity).toFixed(2)}</td>
                                            <td>{data.unit}</td>
                                            <td style={{textAlign:"right"}}>{parseFloat(data.amount).toFixed(2)}</td>
                                            <td style={{textAlign:"right"}}>{parseFloat(data.invoice_qty).toFixed(2)}</td>
                                            <td style={{textAlign:"right"}}>{parseFloat(data.invoice_amt).toFixed(2)}</td>
                                            
                                        

                                        </tr>))}
                                    
                                </tbody>
                                <tfoot>
                                    <tr>
                                    <td> </td>
                                            <td> </td>
                                            <td style={{width:"30%"}}> </td>
                                            <td> </td>
                                            <td> </td>
                                          
                                <td style={{fontWeight:"bold",color:"red",textAlign:"right"}}>Grand Toal</td>
                                <td style={{fontWeight:"bold",color:"red",textAlign:"right"}}>{this.state.popup_total}</td>
                                <td style={{fontWeight:"bold",color:"red",textAlign:"right"}}> </td>
                                <td style={{fontWeight:"bold",color:"red",textAlign:"right"}}> </td>
                                </tr>
                                </tfoot>
                                </table>
                                </div>
                                </div>
                                <div class="modal-footer">
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

</>

        );


    }
}
export default ViewOrderNew